import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { Page404Component } from "./en/pages/page404/page404.component";
const routes: Routes = [
  { path: '', redirectTo: '/ar', pathMatch: 'full' },
  { path: 'en', loadChildren: () => import('./en/en-routing.module').then(m => m.EnRoutingModule) },
  { path: 'ar', loadChildren: () => import('./ar/ar-routing.module').then(m => m.ArRoutingModule) },
  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
